import { Component, Input } from '@angular/core';
import { faSquareXmark } from '@fortawesome/free-solid-svg-icons';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { WhatsappService } from 'src/app/pages/privado/services/whatsapp/whatsapp.service';
@Component({
  selector: 'app-modal-vencimento-plano',
  templateUrl: './modal-vencimento-plano.component.html',
  styleUrls: ['./modal-vencimento-plano.component.css']
})
export class ModalVencimentoPlanoComponent {
  faSquareXmark = faSquareXmark;
  @Input() dependentes: any;
  documentTypeList: Array<any> = [];
  constructor(
    private toast: ToastrService,
    public activeModal: NgbActiveModal,
    private cookieService: CookieService,
    private whatsappService: WhatsappService
  ) { }
  // async inputFileChange(event:any){
  //   if(event.target.files && event.target.files[0]){
  //     let file = event.target.files[0];       
  //     let md5 = new Md5();
  //     let byteArrray = await toByteArray(file);
  //     md5.appendByteArray(new Uint8Array(byteArrray as ArrayBuffer));
  //     let base64 = await toBase64(file);
  //     this.documentTypeList.push({ file: base64.toString().split(",")[1], fileName: file.name, contentType: file.type });
  //   }
  // }
  adicionarArquivos(event: any) {
    if (this.documentTypeList.length > 0) {
      this.documentTypeList = [...this.documentTypeList, event];
    } else {
      this.documentTypeList = event;
    }
  }
  removeFile(valor: any) {
    this.documentTypeList = this.documentTypeList.filter(
      (a: any) => {
        return a.fileName != valor;
      }
    );
  }
  fecharModal() {
    let date = new Date();
    date.setHours(date.getHours() + 12);
    document.cookie = "vencimentoPlano=true;" + "expires=" + date;
    this.activeModal.dismiss(null)
  }
  encaminharDocumentos() {
    if (this.documentTypeList.length == 0) {
      this.toast.error('Você precisa incluir um ou mais arquivos!')
    } else {
      this.whatsappService.PostDeclaracaoMatricula(this.documentTypeList).subscribe({
        next: res => {
          this.toast.success('Comprovante enviado com Sucesso!');
          this.activeModal.dismiss(null);
        },
        error: err => {
          this.toast.error('Ocorreu algum erro!');
          this.activeModal.dismiss(null);
        }
      });
    }
  }
}
const toBase64 = (file: any) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});
const toByteArray = (file: any) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsArrayBuffer(file);
  reader.onload = () => resolve(new Uint8Array(reader.result as ArrayBuffer));
  reader.onerror = error => reject(error);
});